import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=6fcc9b10"
import script from "./Master.vue?vue&type=script&lang=js"
export * from "./Master.vue?vue&type=script&lang=js"
import style0 from "./Master.vue?vue&type=style&index=0&id=6fcc9b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports